import { styled } from "@mui/material";
import { ColorSAP } from "../../ontego-ui";

const Styled = {};

Styled.TotalCostContainer = styled("div")(() => ({
    display: 'flex',
    flexDirection: 'column',
    boxSizing: "border-box",
    padding: '32px 40px 32px 40px',
    borderRadius: 16,
    width: "100%",
    height: "100%",
    backgroundColor: ColorSAP.primary[70],
    color: ColorSAP.neutral[0],
}));

Styled.TotalCost = styled("div")(() => ({
    textAlign: "center",
}));

export default Styled;
